// Mobile card swipers. Initialised per element (not by indexed class) because
// filter replacements and Load more appends repeat the per-page index classes.
function initCollectionCardSwipers() {
  document.querySelectorAll('#CollectionProductGrid .swiper').forEach(function (el) {
    if (el.swiper) return;
    new Swiper(el, {
      slidesPerView: 1,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

initCollectionCardSwipers();
document.addEventListener('product-grid:updated', initCollectionCardSwipers);
